import { isProgramSiteContextError } from '../program/programSiteContext.js';

export function isAbxWorkspaceContentError(error) {
    return (
        isProgramSiteContextError(error) ||
        error?.status === 401 ||
        error?.code === 'ABX_PROGRAM_NOT_ENABLED'
    );
}

export function isAbxMutationPermissionError(error) {
    return error?.status === 403;
}
